<div class="search-page-anchor"></div>
<div class="grid grid-cols-1 md:grid-cols-12 mt-10 px-3 sm:px-5 lg:px-0">
  <div class="md:col-start-3 md:col-span-8">
    <h3 class="text-center justify-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-10">Comece a sua busca por imóveis de leilão disponíveis</h3>
  </div>
</div>
<div class="grid grid-cols-1 md:grid-cols-12 mt-4 mb-10 px-3 sm:px-5 lg:px-0">
  <div class="md:col-start-3 md:col-span-8">
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-loose">Encontramos imóveis que correspondem ao que você está procurando. Explore as opções e use os filtros para refinar sua busca e encontrar a melhor oportunidade.</p>
  </div>
</div>

<div class="search-mobile-filters-anchor lg:hidden"></div>
<div *ngIf="totalItems > 0" class="space-y-3 px-3 sm:px-5 lg:hidden">
  <button type="button"
          (click)="openMobileFilters()"
          class="inline-flex w-full items-center justify-between rounded-md border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100">
    <span>Filtros</span>
    <span class="inline-flex min-w-6 items-center justify-center rounded-md bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700">
      {{ activeFilterCount }}
    </span>
  </button>
  <button type="button"
          *ngIf="appliedEstate && appliedCity"
          (click)="openNotificationModal()"
          class="inline-flex w-full items-center justify-center rounded-md border border-blue-200 bg-blue-50 px-4 py-3 text-sm font-medium text-blue-700 shadow-sm hover:bg-blue-100 hover:text-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-100">
    Criar alerta para esta busca
  </button>
</div>

<div *ngIf="totalItems === 0" class="px-3 sm:px-5 lg:hidden">
  <ng-container *ngIf="(realEstates | async) !== null && !searchAccessMessage && !searchLoadErrorMessage">
    <ng-container *ngTemplateOutlet="noResultsNotificationTemplate"></ng-container>
  </ng-container>
  <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
</div>

<div class="grid grid-cols-1 lg:grid-cols-24 my-10 px-3 sm:px-5 lg:px-0">
  <div class="search-desktop-filters-anchor hidden lg:block lg:col-span-5 lg:col-start-3">
    <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
  </div>


  <div [ngClass]="totalItems > 0 ? 'col-span-1 lg:col-span-15 lg:ps-5 mt-5 lg:mt-0' : 'hidden'">

    <div *ngIf="totalItems > 0" class="grid grid-cols-1 gap-3 lg:grid-cols-24 items-center mb-5 mt-5 lg:mt-15">
      <div class="lg:hidden rounded-md bg-white px-4 py-3 text-sm text-gray-700 shadow-sm">
        Mostrando <span class="font-bold">{{ shownCount }}</span> de <span class="font-bold">{{ totalItems }}</span> imóveis
      </div>
      <div
        class="lg:col-span-9 lg:col-end-16 items-center">
        <div class="flex justify-end items-center gap-3 lg:gap-5">
          <label
                 class="text-sm font-bold text-end text-gray-700 w-28 lg:w-full">
            <span class="lg:hidden">Organizar</span>
            <span class="hidden lg:inline">ORGANIZAR POR</span>
          </label>
          <select
                  class="bg-white border-white text-gray-900 text-sm hover:focus::active:border-white   hover:focus::active:border-0 hover:focus::active:ring-white  focus:border-white w-full p-2.5"
                  [ngModel]="viewOrder"
                  (ngModelChange)="setViewOrder($event)">
            <option [ngValue]="'newer'">Mais recente</option>
            <option [ngValue]="'nearest-auction'">Leilão mais próximo</option>
            <option [ngValue]="'highest-discount'">Maior desconto</option>
            <option [ngValue]="'lowest-price'">Menor preço</option>
            <option [ngValue]="'highest-price'">Maior preço</option>
          </select>
        </div>
      </div>
      <div
        class="lg:col-span-9 lg:col-end-25 items-center">
        <div class="flex justify-end items-center gap-3 lg:gap-5">
          <label
                 class="text-sm font-bold text-end text-gray-700 w-28 lg:w-full">
            <span class="lg:hidden">Visualizar</span>
            <span class="hidden lg:inline">VISUALIZAR POR</span>
          </label>
          <select
                  class="bg-white border-white text-gray-900 text-sm hover:focus::active:border-white   hover:focus::active:border-0 hover:focus::active:ring-white  focus:border-white w-full p-2.5"
                  [ngModel]="viewMode"
                  (ngModelChange)="setViewMode($event)">
            <option [ngValue]="'list'">Lista</option>
            <option [ngValue]="'map'">Mapa</option>
          </select>
        </div>
      </div>
    </div>


    <div *ngIf="totalItems > 0 && viewMode === 'list'" class="relative">
      <div
        *ngIf="isPaginating"
        class="absolute inset-0 z-10 flex min-h-48 items-start justify-center rounded-md bg-white/75 pt-8 backdrop-blur-[1px]">
        <div class="inline-flex items-center gap-3 rounded-md border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-sm">
          <span class="h-4 w-4 animate-spin rounded-full border-2 border-blue-600 border-t-transparent"></span>
          Carregando página...
        </div>
      </div>
      <div
        class="grid grid-col-1 gap-5 transition-opacity xl:grid-cols-2 2xl:gap-5 xl:gap-3 lg:grid-cols-2 lg:gap-3"
        [ngClass]="isPaginating ? 'opacity-40' : 'opacity-100'">
        @for (realEstate of getListRealEstates(realEstates | async); track realEstate.link; let index = $index) {
          <app-real-estate-card [realEstate]="realEstate"></app-real-estate-card>
        }
      </div>
    </div>

    <!-- Paginator + count label -->
    <div *ngIf="totalItems > 0 && viewMode === 'list'"
         class="flex flex-col sm:flex-row items-center justify-center mt-6 px-2">
      <div class="inline-flex items-center gap-0"
           *ngIf="totalPages > 1">
        <button type="button"
                (click)="prevPage()"
                [disabled]="currentPage === 1 || isPaginating"
                class="px-3 py-2 border text-sm"
                [ngClass]="currentPage === 1 || isPaginating ? 'text-gray-400 border-gray-200 bg-gray-50 cursor-not-allowed rounded-l-md' : 'text-gray-700 border-gray-300 hover:bg-gray-50 rounded-l-md'">
          <
        </button>
        <ng-container *ngFor="let p of displayedPages">
          <ng-container *ngIf="p !== '…'; else ellipsis">
            <button type="button"
                    (click)="goToPage(p)"
                    [disabled]="isPaginating"
                    class="px-3 py-2 border text-sm"
                    [ngClass]="p === currentPage ? 'bg-blue-600 text-white border-blue-600' : (isPaginating ? 'text-gray-400 border-gray-200 bg-gray-50 cursor-not-allowed' : 'text-gray-700 border-gray-300 hover:bg-gray-50')">
              {{ p }}
            </button>
          </ng-container>
          <ng-template #ellipsis>
            <span class="px-3 py-2 text-gray-500 select-none">…</span>
          </ng-template>
        </ng-container>
        <button type="button"
                (click)="nextPage()"
                [disabled]="currentPage === totalPages || isPaginating"
                class="px-3 py-2 border text-sm"
                [ngClass]="currentPage === totalPages || isPaginating ? 'text-gray-400 border-gray-200 bg-gray-50 cursor-not-allowed rounded-r-md' : 'text-gray-700 border-gray-300 hover:bg-gray-50 rounded-r-md'">
          >
        </button>
      </div>
      <div class="ms-5 text-sm text-gray-700 font-normal mb-3 sm:mb-0">
        Mostrando <span class="font-bold">{{ shownCount }}</span> de <span class="font-bold">{{ totalItems }}</span> imóveis
      </div>
    </div>

    <div *ngIf="(realEstates | async) !==  null && viewMode === 'map'"
         class="relative">
      <google-map
        mapId="main"
        width="100%"
        height="600px"
        [center]="mapCenter"
        [zoom]="mapZoom"
        (mapInitialized)="onMapInitialized()">
        @for (re of getMapRealEstates(realEstates | async); track re.link) {
          @if (re.lat !== null && re.lng !== null) {
            <map-advanced-marker #m="mapAdvancedMarker"
                                 [position]="getMarkerPosition(re)"
                                 (mapClick)="openInfoWindow(info, re, m)">

            </map-advanced-marker>
          }
        }
        <map-info-window #info="mapInfoWindow">
                @if (selectedRealEstateForMap) {
                  <div class="grid grid-cols-1">
                    <app-real-estate-card [realEstate]="selectedRealEstateForMap"></app-real-estate-card>
                  </div>
                }
              </map-info-window>
      </google-map>
    </div>
  </div>

  <div *ngIf="searchLoadErrorMessage"
       class="col-span-1 lg:col-span-15 lg:ps-5 mt-5 lg:mt-0">
    <div class="rounded-md border border-amber-200 bg-amber-50 px-5 py-8 text-center shadow-sm">
      <p class="text-base font-normal leading-relaxed text-amber-800 font-['Inter']">
        {{ searchLoadErrorMessage }}
      </p>
    </div>
  </div>

  <div *ngIf="(realEstates | async) !== null && totalItems === 0 && !searchAccessMessage && !searchLoadErrorMessage"
       class="hidden lg:block col-span-1 lg:col-span-19 xl:col-span-15 lg:ps-5 mt-5 lg:mt-0">
    <ng-container *ngTemplateOutlet="noResultsNotificationTemplate"></ng-container>
  </div>
</div>

@if (isMobileFiltersOpen) {
  <div class="fixed inset-0 z-[70] bg-slate-900/50 lg:hidden" role="dialog" aria-modal="true" aria-labelledby="mobile-filters-title">
    <button type="button"
            class="absolute inset-0 h-full w-full cursor-default"
            aria-label="Fechar filtros"
            (click)="closeMobileFilters()"></button>
    <div class="absolute bottom-0 left-0 right-0 max-h-[88vh] overflow-y-auto rounded-t-2xl bg-white p-4 shadow-2xl">
      <div class="mb-4 flex items-center justify-between">
        <h4 id="mobile-filters-title" class="text-lg font-semibold text-gray-900">Filtros</h4>
        <button type="button"
                (click)="closeMobileFilters()"
                class="rounded-md p-2 text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-100"
                aria-label="Fechar filtros">
          <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 6l12 12M18 6 6 18"/>
          </svg>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
    </div>
  </div>
}

@if (searchAccessMessage) {
  <div class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/50 px-4 py-6" role="dialog" aria-modal="true" aria-labelledby="search-access-title">
    <div class="w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-6 text-center shadow-2xl md:p-8">
      <h4 id="search-access-title" class="text-gray-900 text-2xl font-extrabold font-['Inter'] leading-8">
        Acesse os resultados da busca
      </h4>
      <p class="mt-4 text-gray-500 text-base font-normal font-['Inter'] leading-relaxed">
        {{ searchAccessMessage }}
      </p>
      <div class="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <a routerLink="/login"
           class="inline-flex w-full items-center justify-center rounded-md border border-gray-300 bg-white px-5 py-3 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100">
          Login
        </a>
        <a routerLink="/planos"
           class="inline-flex w-full items-center justify-center rounded-md bg-blue-700 px-5 py-3 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-200">
          Ver planos
        </a>
      </div>
    </div>
  </div>
}

<!-- Notification Modal -->
<app-notification-modal
  *ngIf="showNotificationModal"
  [searchState]="appliedEstate"
  [searchCity]="appliedCity"
  [searchType]="getSelectedType()"
  [searchDiscount]="appliedMinDiscount"
  (closeModal)="closeNotificationModal()"
  (notificationSaved)="onNotificationSaved()">
</app-notification-modal>

<ng-template #noResultsNotificationTemplate>
  <div role="alert" class="mb-5 rounded-md border border-amber-200 bg-amber-50 px-4 py-4 shadow-sm">
    <div>
      <p class="text-sm font-semibold text-amber-900 font-['Inter']">Nenhum imóvel encontrado</p>
      <p class="mt-1 text-sm font-normal leading-relaxed text-amber-800 font-['Inter']">
        Ajuste os filtros e clique em Buscar para ver mais oportunidades.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #filtersTemplate>
  <div class="bg-white p-6 rounded-md shadow">
    <button type="button"
            *ngIf="appliedEstate && appliedCity && totalItems > 0"
            (click)="openNotificationModal()"
            class="cursor-pointer text-blue-700 hover:text-blue-800 focus:ring-4 focus:ring-blue-300 text-sm font-medium font-['Inter'] rounded-md flex items-center mb-4">
      Criar alerta para esta busca
    </button>

    <p class="text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
      Estado<span>*</span>
    </p>
    <select
            [(ngModel)]="selectedEstate"
            (ngModelChange)="updateCities()"
            aria-required="true"
            class="bg-gray-50 border mt-2 border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
      <option value="" disabled selected>Selecionar Estado</option>
      <option *ngFor="let estate of estates" [ngValue]="estate">{{ estate }}</option>
    </select>

    <p class="mt-5 justify-start text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
      Cidade<span>*</span>
    </p>
    <select
            [(ngModel)]="selectedCity"
            [disabled]="!selectedEstate"
            aria-required="true"
            class="bg-gray-50 border mt-2 border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400">
      <option [ngValue]="null" disabled>Selecionar Cidade</option>
      <option *ngFor="let city of cities" [ngValue]="city">{{ city.city }}</option>
    </select>

    <p class="mt-5 justify-start text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
      Tipo de imóvel
    </p>
    <div class="mt-2 max-h-64 overflow-y-auto rounded-md border border-gray-100 p-2">
      <label *ngFor="let type of visibleRealEstateTypes" class="flex items-center py-1.5">
        <input type="checkbox"
               [checked]="selectedRealEstateTypes.get(type)"
               (change)="toggleRealEstateType(type, $event)"
               class="ms-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
        <span class="ml-2 text-sm font-medium text-gray-900">{{ type }}</span>
      </label>
      <button type="button"
              (click)="toggleRealEstateTypesVisibility()"
              class="mt-2 px-2 py-1 text-sm font-medium text-blue-700 hover:text-blue-800">
        {{ showAllRealEstateTypes ? 'Mostrar menos' : 'Mostrar mais tipos' }}
      </button>
    </div>

    <fieldset class="mt-5">
      <legend class="text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
        Tipo jurídico
      </legend>
      <div class="mt-1 flex justify-end">
        <button type="button"
                *ngIf="pendingLegalType"
                (click)="clearLegalType()"
                class="text-sm font-medium text-blue-700 hover:text-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-100 rounded-md px-2 py-1">
          Limpar
        </button>
      </div>
      <div class="mt-2 space-y-2">
        @for (legalType of LEGAL_TYPE_FILTERS; track legalType.id) {
          <label
            (click)="selectLegalType(legalType.id)"
            class="flex cursor-pointer items-center rounded-md border px-3 py-2.5 text-sm font-medium transition-colors"
            [ngClass]="pendingLegalType === legalType.id ? 'border-blue-200 bg-blue-50 text-blue-800' : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50'">
            <input
              type="radio"
              [checked]="pendingLegalType === legalType.id"
              class="h-4 w-4 border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500">
            <span class="ml-3">{{ legalType.label }}</span>
          </label>
        }
      </div>
    </fieldset>

    <p class="mt-5 justify-start text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
      Desconto
    </p>
    <input type="number"
           [(ngModel)]="minDiscount"
           min="0"
           max="100"
           class="border border-gray-300 mt-2 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
           placeholder="Ex: 10">

    <fieldset class="mt-5">
      <legend class="text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
        Lance mínimo
      </legend>
      <p class="mt-1 text-sm font-normal leading-relaxed text-gray-500 font-['Inter']">
        Os valores utilizados no filtro consideram o menor lance disponível informado no anúncio do imóvel.
      </p>
      <div class="mt-1 flex justify-end">
        <button type="button"
                *ngIf="selectedPriceRange"
                (click)="clearPriceRange()"
                class="text-sm font-medium text-blue-700 hover:text-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-100 rounded-md px-2 py-1">
          Limpar
        </button>
      </div>
      <div class="mt-2 space-y-2">
        @for (range of PRICE_RANGES; track range.id) {
          <label
            (click)="selectPriceRange(range.id)"
            class="flex cursor-pointer items-center rounded-md border px-3 py-2.5 text-sm font-medium transition-colors"
            [ngClass]="selectedPriceRange === range.id ? 'border-blue-200 bg-blue-50 text-blue-800' : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50'">
            <input
              type="radio"
              [checked]="selectedPriceRange === range.id"
              class="h-4 w-4 border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500">
            <span class="ml-3">{{ range.label }}</span>
          </label>
        }
      </div>
    </fieldset>

    <fieldset class="mt-5">
      <legend class="text-gray-900 text-base font-semibold font-['Inter'] leading-tight">
        Valor de avaliação
      </legend>
      <p class="mt-1 text-sm font-normal leading-relaxed text-gray-500 font-['Inter']">
        O valor de avaliação representa uma estimativa de mercado do imóvel informada no edital ou anúncio do leilão.
      </p>
      <div class="mt-1 flex justify-end">
        <button type="button"
                *ngIf="pendingAssessmentRange"
                (click)="clearAssessmentRange()"
                class="text-sm font-medium text-blue-700 hover:text-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-100 rounded-md px-2 py-1">
          Limpar
        </button>
      </div>
      <div class="mt-2 space-y-2">
        @for (range of ASSESSMENT_RANGES; track range.id) {
          <label
            (click)="selectAssessmentRange(range.id)"
            class="flex cursor-pointer items-center rounded-md border px-3 py-2.5 text-sm font-medium transition-colors"
            [ngClass]="pendingAssessmentRange === range.id ? 'border-blue-200 bg-blue-50 text-blue-800' : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50'">
            <input
              type="radio"
              [checked]="pendingAssessmentRange === range.id"
              class="h-4 w-4 border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500">
            <span class="ml-3">{{ range.label }}</span>
          </label>
        }
      </div>
    </fieldset>

    <div class="grid 2xl:grid-cols-2 gap-5 mt-5">
      <div class="col-span-1">
        <button type="button"
                (click)="clearFilters()"
                class="cursor-pointer w-full bg-white rounded-md outline outline-1 outline-gray-200 text-gray-900 text-sm font-medium font-['Inter'] leading-tight px-5 py-2.5 hover:bg-gray-50 focus:ring-4 focus:ring-gray-300">
          Limpar filtros
        </button>
      </div>
      <div class="col-span-1">
        <button type="button"
                [disabled]="!canSearch"
                (click)="applySearchFromFilters()"
                class="text-white focus:ring-4 focus:ring-blue-300 text-sm font-medium font-['Inter'] rounded-md px-5 py-2.5 w-full"
                [ngClass]="canSearch ? 'cursor-pointer bg-blue-700 hover:bg-blue-800' : 'cursor-not-allowed bg-gray-300 text-gray-500'">
          Buscar
        </button>
      </div>
    </div>
    @if (!canSearch) {
      <p class="mt-3 text-sm text-gray-500 font-normal font-['Inter'] leading-relaxed">
        {{ searchRequirementsMessage }}
      </p>
    }
  </div>
</ng-template>
